import {HttpCrudDataSource} from '../../../../../../core/data-source/http-crud.data-source';
import {fromJson, toJson} from '../../../../../../core/data-source/json.mapper';
import {httpService} from '../../../../../../core/services/http.service';
import {PTVehicleFilterRecord} from '../../../../records/pt-vehicle-filter.record';

export class VehicleDriverFilterCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/journeys/filter';

    async getStateFilter(): Promise<boolean> {
        const {data}: any = await httpService.get(this.apiPath);
        const filter: PTVehicleFilterRecord = fromJson(PTVehicleFilterRecord, data.rows[0]);
        return filter.isActive();
    }

    async saveFilter(record: PTVehicleFilterRecord): Promise<PTVehicleFilterRecord> {
        return httpService.post(this.apiPath, toJson(record)).then((response: any) => {
            return fromJson(PTVehicleFilterRecord, response.data.rows[0]);
        });
    }
}
